import { useEffect, useState } from 'react';
import useEftposAccount from '../../../Hooks/UseEftposAccount';
import LoadingPanel from '../../../Abstracts/Components/LoadingPanel';
import useEftposPosLists from '../../../Hooks/UseEftposPosLists';
import useUserApi, { ErrorHandler } from '../../../Services/UserApi';
import EditMenuForm, { EditableEftposPosList } from './EditMenuForm';
import { useHistory, useParams } from 'react-router-dom';
import { BackButton } from '../BreadCrumbs';
import useQuery from '../../../Hooks/UseQuery';

export default function EditMenu() {
	const { eftposAccount } = useEftposAccount();
	const eftposPosLists = useEftposPosLists();
	const [menu, setMenu] = useState<EditableEftposPosList>();

	const { id: menuId } = useParams<{ id: string }>();

	const query = useQuery();
	const context = query.get('context');

	let backLocation = '/menus';
	switch (context) {
		case 'dashboard':
			backLocation = '/';
			break;
		case 'bookings':
			backLocation = `/bookings`;
			break;
		case 'menus':
			backLocation = `/menus`;
			break;
	}

	useEffect(() => {
		if (!eftposAccount || !eftposPosLists || !menuId) {
			return;
		}
		const foundMenu = eftposPosLists.find((m) => m.EftposPosListId === parseInt(menuId));
		if (!foundMenu) {
			return;
		}
		const editableMenu: EditableEftposPosList = {
			...foundMenu,
			EftposPosListEftposAccountId: eftposAccount.EftposAccountId,
			items: foundMenu.items.map((i) => ({
				...i,
				EftposPosListItemPrice: window.formatCurrency('' + i.EftposPosListItemPrice),
			})),
		};
		setMenu(editableMenu);
	}, [eftposAccount, eftposPosLists, menuId]);

	const userApi = useUserApi();
	const history = useHistory();

	const saveMenu = (menu: EditableEftposPosList) => {
		return userApi({
			route: 'eftpos/api',
			data: {
				action: 'saveEftposPosList',
				eftposPosList: menu,
			},
			errorMessage: 'Error saving menu',
		})
			.then(() => history.push(backLocation))
			.catch((e: unknown) => ErrorHandler.toast(e));
	};

	if (!eftposAccount || !eftposPosLists || !menu) {
		return <LoadingPanel />;
	}

	return (
		<>
			<BackButton text="Back" to={backLocation} />
			<EditMenuForm
				menu={menu}
				setMenu={setMenu}
				onSave={saveMenu}
				isFirstMenu={false}
				saveButtonText="Save menu"
			/>
		</>
	);
}
